<template>
  <div class="card_box">
    <Card>
      <div slot="title" class="titlebox">
        <span class="title">{{$t('label.Inquiry.InquiryFor')}}</span>
        <Icon type="ios-create-outline" class="applyicon" />
        <!-- <Button type="primary" long  class="add">
          <Icon type="ios-add" style="margin-right:5px;" />添加
        </Button>-->
      </div>
      <!-- 主表 -->
      <Form ref="formdata" :model="formdata" :rules="rule">
        <table class="form-table form-table-print">
          <tbody>
            <tr>
              <!-- 询价编号 -->
              <th class="requiredIitm">{{$t('label.Inquiry.InquiryNo')}}</th>
              <td>
                <Form-item prop="inquiryId">
                  <Input type="text" v-model="formdata.inquiryId" disabled />
                </Form-item>
              </td>
              <!-- 申请人 -->
              <th class="requiredIitm">{{$t('label.Inquiry.Client')}}</th>
              <td>
                <Form-item prop="applicantUserId">
                  <Input type="text" v-model="sqr" disabled />
                </Form-item>
              </td>
              <!-- 申请日期 -->
              <th class="requiredIitm">{{$t('label.Inquiry.EntrustDate')}}</th>
              <td>
                <Form-item prop="applyDate">
                  <ab-date
                    :disabled="true"
                    style="width:100%;"
                    v-model="formdata.applyDate"
                    format="yyyy-MM-dd"
                  ></ab-date>
                </Form-item>
              </td>
            </tr>
            <!-- 新加功能 公司-据点选择 -->
            <tr>
              <!-- 公司 -->
              <th class="requiredIitm">
                <span>{{ $t('InquiryApply.InquiryCompany') }}</span>
              </th>
              <td>
                <Form-item prop="applyCompanyName">
                  <Input type="text" v-model="formdata.applyCompanyName" disabled />
                </Form-item>
              </td>
              <!-- 据点 -->
              <th class="requiredIitm">
                <span>{{ $t('InquiryApply.InquiryStronghoId') }}</span>
              </th>
              <td>
                <Form-item prop="applyStrongholdName">
                  <Input type="text" v-model="formdata.applyStrongholdName" disabled />
                </Form-item>
              </td>
              <!-- 申请部门 -->
              <th class="requiredIitm">{{$t('label.Inquiry.EntrustedDepartment')}}</th>
              <td>
                <Form-item prop="applyDepartmentName">
                  <Input type="text" v-model="formdata.applyDepartmentName" disabled />
                </Form-item>
              </td>
            </tr>
            <tr>
              <!-- 报价截止日 -->
              <th class="requiredIitm">{{$t('label.Inquiry.Deadline')}}</th>
              <td>
                <Form-item prop="quoteDeadline">
                  <ab-date
                    disabled
                    style="width:100%;"
                    v-model="formdata.quoteDeadline"
                    format="yyyy-MM-dd"
                  ></ab-date>
                </Form-item>
              </td>
              <!-- 是否拆分报价 -->
              <th v-if="userId!=='admin'" class="requiredIitm">{{$t('label.InquiryOfferApprove.Separable')}}</th>
              <td v-if="userId!=='admin'"  style="text-align:left;" colspan="3">
                <Form-item prop="breakupBidFlg">
                  <div style="display:flex;">
                    <RadioGroup v-model="formdata.breakupBidFlg" @on-change="setValue($event)">
                      <Tooltip max-width="500" :content="$t('label.Inquiry.offer.tipsYes')">
                        <Radio
                          :disabled="permission.swgys.breakupBidFlg!=='w'"
                          label="1"
                        >{{$t('LABEL-011')}}</Radio>
                      </Tooltip>
                      <Tooltip max-width="500" :content="$t('label.Inquiry.offer.tipsNo')">
                        <Radio
                          :disabled="permission.swgys.breakupBidFlg!=='w'"
                          label="0"
                        >{{$t('LABEL-010')}}</Radio>
                      </Tooltip>
                    </RadioGroup>
                  </div>
                </Form-item>
              </td>
            </tr>
            <tr>
              <!-- 案件名 -->
              <th class="requiredIitm"><span>{{$t('label.Inquiry.caseName')}}</span></th>
              <td colspan="6">
                <Form-item prop="caseName">
                  <Input type="text" v-model="formdata.caseName" :disabled="permission.swgys.caseName!=='w'"  />
                </Form-item>
              </td>
            </tr>
         </tbody>
        </table>
        <div>
          <div class="table_box">
            <div class="itemTitle">
              <Icon type="ios-information-circle" class="icon" />
              <span style="cursor: pointer;font-size:13px;">{{$t('label.Inquiry.notice.tips')}}</span>
            </div>
          </div>
        </div>
        
      </Form>
      <!-- 实物购入 -->
      <Card
        style="margin-top:15px;"
        :class="{'cardnonepadding':!formDynamic.items || formDynamic.items.length===0}"
        v-if="formDynamic.items && validate_d"
      >
        <div slot="title" class="title_a_box">
          <span class="title">{{$t('label.Inquiry.PhysicalA')}}</span>
          <!-- <Button type="primary" long @click="handleAdd(0)" class="add">
          <Icon type="ios-add" style="margin-right:5px;" />添加
          </Button>-->
        </div>
        <Form ref="formDynamic" :rules="rules" :model="formDynamic" class="form-table-th-margin">
          <div v-for="(item, index) in formDynamic.items" :key="index">
            <!-- 实物购入明细部分 -->
            <div
              :class="{'content':index !== formDynamic.items.length-1}"
              v-if="getdisplay(item,0)"
            >
              <table class="form-table form-table-print">
                <tbody>
                  <tr>
                    <th class="requiredIitm">{{$t('label.Inquiry.Physical.Item')}}</th>
                    <td>
                      <Form-item :prop="'items.' + index + '.itemName'" :rules="rules.itemName">
                        <Input type="text" v-model="item.itemName" placeholder disabled />
                      </Form-item>
                    </td>
                    <th class="requiredIitm">{{$t('label.Inquiry.Physical.Specifications')}}</th>
                    <td>
                      <Form-item
                        :prop="'items.' + index + '.specifications'"
                        :rules="rules.specifications"
                      >
                        <Input type="text" v-model="item.specifications" placeholder disabled />
                      </Form-item>
                    </td>
                    <th class="requiredIitm">{{$t('label.Inquiry.Physical.Sum')}}</th>
                    <td>
                      <Form-item :prop="'items.' + index + '.quantity'" :rules="rules.quantity">
                        <InputNumber
                          class="wrongNumber"
                          :active-change="false"
                          style="width:100%;"
                          :min="0"
                          v-model="item.quantity"
                          disabled
                        ></InputNumber>
                      </Form-item>
                    </td>
                  </tr>

                  <tr>
                    <th class="requiredIitm">{{$t('label.Inquiry.Physical.Satisfied')}}</th>
                    <td>
                      <Form-item
                        :prop="'items.' + index + '.deliveryDeadline'"
                        :rules="rules.deliveryDeadline"
                      >
                        <ab-date
                          disabled
                          style="width:100%;"
                          v-model="item.deliveryDeadline"
                          format="yyyy-MM-dd"
                        ></ab-date>
                      </Form-item>
                    </td>
                    <th class>{{$t('label.Inquiry.Physical.Attachment')}}</th>
                    <td>
                      <ab-upload v-model="item.file" abPermission="w" :disabled="true" :format="['pdf','xlsx','xls','doc','docx','ppt','pptx','ofd','jpg','png','jpeg','bmp']"></ab-upload>
                    </td>
                    <th class>{{$t('label.Inquiry.Physical.Note')}}</th>
                    <td>
                    <Tooltip
                        style="width:100%;margin-top:5px;"
                        max-width="400"
                        :disabled="item.note===''"
                        :content="item.note"
                        :transfer="true"
                      >  
                      <Form-item :prop="'items.' + index + '.note'">
                        <Input type="text" v-model="item.note" placeholder disabled />
                      </Form-item>
                    </Tooltip>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- 理由内容 -->
              <!-- <div class="typebox" v-if="item.swgysList && item.swgysList.length===1 && !item.flg">
                <span>相見積もり徹底できない理由 :</span>
                <Form-item :prop="'items.' + index + '.incompleteQr'" :rules="rules.incompleteQr">
                  <RadioGroup v-model="item.incompleteQr">
                    <Radio label="0" disabled>丰田事业体</Radio>
                    <Radio label="1" disabled>专利持有公司</Radio>
                    <Radio label="2" disabled>大学、研究机构</Radio>
                    <Radio label="3" disabled>合作项目</Radio>
                    <Radio label="4" disabled>其他：（要记入）</Radio>
                  </RadioGroup>
                </Form-item>
                <Form-item
                  :prop="'items.' + index + '.incompleteQrt'"
                  :rules="rules.incompleteQrt"
                  v-if="item.incompleteQr==='4'"
                >
                  <Input type="text" v-model="item.incompleteQrt" placeholder disabled />
                </Form-item>
              </div>-->
              <!-- 实物购入供应商部分 -->
              <div style="margin-top:15px;">
                <div
                  style="display:flex;justify-content:space-between;margin-bottom:15px;align-items:center;"
                >
                  <!-- <div>
                  <Button type="primary" @click="add(index,0)" style="margin-right:10px;">
                    <Icon type="ios-add" style="margin-right:5px;" />添加供应商
                  </Button>
                  <Button
                    type="primary"
                    @click="copy(index,0)"
                    style="margin-right:10px;"
                    v-if="formDynamic.items[0].swgysList.length>0 && index!==0 && formDynamic.items.length>0"
                  >
                    <Icon type="ios-add" style="margin-right:5px;" />复制供应商
                  </Button>
                  <Button type="error" @click="handleRemove(index,0)">
                    <Icon type="ios-alert-outline" style="margin-right:5px;" />删除明细
                  </Button>
                  </div>-->
                </div>
                <div style="text-align:left;width:100%;color: red;font-size: 12px">
                  <span>{{$t('label.InquiryOfferApprove.Tips001')}}</span>
                </div>
                <Table
                  border
                  :columns="userId==='admin' ? columns_all : columns"
                  :data="item.swgysList"
                  :no-data-text="''"
                  v-if="item.swgysList && item.swgysList.length>0"
                >
                  <!-- 供应商名称 -->
                  <template slot-scope="{ row }" slot="vendorName">
                    <Tooltip
                      max-width="400"
                      style="display:flex;width:100%;"
                      :disabled="item.swgysList[row._index].vendorName===''"
                      :content="item.swgysList[row._index].vendorName"
                      :transfer="true"
                    >
                      <FormItem
                        :prop="`items.${index}.swgysList.${row._index}.vendorName`"
                        :rules="rules.vendorName"
                      >
                        <Input
                          type="text"
                          disabled
                          v-model="item.swgysList[row._index].vendorName"
                        />
                      </FormItem>
                    </Tooltip>
                  </template>
                  <!-- 委托人 -->
                  <template slot-scope="{ row }" slot="client">
                    <FormItem
                      :prop="`items.${index}.swgysList.${row._index}.client`"
                      :rules="rules.client"
                    >
                      <Input type="text" disabled v-model="item.swgysList[row._index].client" />
                    </FormItem>
                  </template>
                  <!-- 联系方式 -->
                  <template slot-scope="{ row }" slot="contact">
                    <Tooltip
                      style="display:flex;width:100%;"
                      max-width="400"
                      :content="item.swgysList[row._index].contact"
                      :transfer="true"
                    >
                      <FormItem
                        :prop="`items.${index}.swgysList.${row._index}.contact`"
                        :rules="rules.contact"
                      >
                        <Input
                          type="text"
                          v-model="item.swgysList[row._index].contact"
                          :maxlength="300"
                          disabled
                        />
                      </FormItem>
                    </Tooltip>
                  </template>
                  <!-- 委托人邮箱 -->
                  <template slot-scope="{ row }" slot="email">
                    <Tooltip
                      max-width="400"
                      style="display:flex;width:100%;"
                      :disabled="item.swgysList[row._index].email===''"
                      :content="item.swgysList[row._index].email"
                      :transfer="true"
                    >
                      <FormItem
                        :prop="`items.${index}.swgysList.${row._index}.email`"
                        :rules="rules.email"
                      >
                        <Input type="text" disabled v-model="item.swgysList[row._index].email" />
                      </FormItem>
                    </Tooltip>
                  </template>
                  <!-- 不含税价格 -->
                  <template slot-scope="{ row }" slot="excludingTaxPrice">
                    <FormItem
                      :prop="`items.${index}.swgysList.${row._index}.excludingTaxPrice`"
                      :rules="returnCheck(item.swgysList[row._index]) ? [{ type:'number',trigger: 'change',validator:(rule,value,callback)=>{priceCheck(rule,value,callback,1,row)}}] : null"
                    >
                      <InputNumber
                        :disabled="permission.swgys.excludingTaxPrice!=='w'"
                        :active-change="false"
                        :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="value => value.replace(/\s?|(,*)/g, '')"
                        :precision="2"
                        style="width:100%;"
                        :min="0"
                        @on-change="numberchange($event,item.swgysList[row._index],0)"
                        v-model="item.swgysList[row._index].excludingTaxPrice"
                      ></InputNumber>
                    </FormItem>
                  </template>
                  <!-- 含税价格 -->
                  <template slot-scope="{ row }" slot="includingTaxPrice">
                    <FormItem
                      :prop="`items.${index}.swgysList.${row._index}.includingTaxPrice`"
                      :rules="returnCheck(item.swgysList[row._index]) ? [{ type:'number',trigger: 'change',validator:(rule,value,callback)=>{priceCheck(rule,value,callback,0,row)}}] : null"
                    >
                      <InputNumber
                        :disabled="permission.swgys.includingTaxPrice!=='w'"
                        @on-change="numberchange($event,item.swgysList[row._index],1)"
                        :active-change="false"
                        :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="value => value.replace(/\s?|(,*)/g, '')"
                        :precision="2"
                        style="width:100%;"
                        :min="0"
                        v-model="item.swgysList[row._index].includingTaxPrice"
                      ></InputNumber>
                    </FormItem>
                  </template>
                  <!-- 比价金额 -->
                  <template slot-scope="{ row }" slot="priceAmount">
                    <FormItem
                      :prop="`items.${index}.swgysList.${row._index}.priceAmount`"
                      :rules="returnCheck(item.swgysList[row._index]) ? rules.priceAmount : null"
                    >
                      <InputNumber
                        :active-change="false"
                        :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="value => value.replace(/\s?|(,*)/g, '')"
                        :precision="2"
                        style="width:100%;"
                        :min="0"
                        disabled
                        v-model="item.swgysList[row._index].priceAmount"
                      ></InputNumber>
                    </FormItem>
                  </template>
                  <!-- 税率 -->
                  <!-- <template slot-scope="{ row }" slot="taxRate">
                    <FormItem
                      :prop="`items.${index}.swgysList.${row._index}.taxRate`"
                      :rules="returnCheck(item.swgysList[row._index]) ? rules.taxRate : null"
                    >
                      <InputNumber
                        disabled
                        :formatter="value => `${value}%`"
                        :parser="value => value.replace('%', '')"
                        style="width:100%;"
                        :precision="2"
                        :min="0"
                        v-model="item.swgysList[row._index].taxRate"
                      ></InputNumber>
                    </FormItem>
                  </template>-->
                  <!-- 发票区分 -->
                  <template slot-scope="{ row }" slot="invoiceType">
                    <FormItem
                      :prop="`items.${index}.swgysList.${row._index}.invoiceType`"
                      :rules="returnCheck(item.swgysList[row._index]) ? rules.invoiceType : null"
                    >
                      <RadioGroup
                        v-model="item.swgysList[row._index].invoiceType"
                        @on-change="numberchange($event,item.swgysList[row._index],2)"
                      >
                        <Radio
                          :disabled="permission.swgys.invoiceType!=='w'"
                          label="0"
                        >{{$t('label.Inquiry.GeneralTicket')}}</Radio>
                        <Radio
                          :disabled="permission.swgys.invoiceType!=='w'"
                          label="1"
                        >{{$t('label.Inquiry.TicketIncrease')}}</Radio>
                      </RadioGroup>
                    </FormItem>
                  </template>
                  <!-- 报价有效开始日 -->
                  <template slot-scope="{ row }" slot="priceStartDate">
                    <Form-item
                      :prop="`items.${index}.swgysList.${row._index}.priceStartDate`"
                      :rules="returnCheck(item.swgysList[row._index]) ? [{ trigger: 'change',validator:(rule,value,callback)=>{validateDate(rule,value,callback,row,0)}}] : null"
                    >
                      <ab-date
                        :disabled="permission.swgys.priceStartDate!=='w'"
                        style="width:100%;"
                        v-model="item.swgysList[row._index].priceStartDate"
                        format="yyyy-MM-dd"
                      ></ab-date>
                    </Form-item>
                  </template>
                  <!-- 报价有效截至日 -->
                  <template slot-scope="{ row }" slot="priceEndDate">
                    <Form-item
                      :prop="`items.${index}.swgysList.${row._index}.priceEndDate`"
                      :rules="returnCheck(item.swgysList[row._index]) ? [{ trigger: 'change',validator:(rule,value,callback)=>{validateDate(rule,value,callback,row,1)}}] : null"
                    >
                      <ab-date
                        :disabled="permission.swgys.priceEndDate!=='w'"
                        style="width:100%;"
                        v-model="item.swgysList[row._index].priceEndDate"
                        format="yyyy-MM-dd"
                      ></ab-date>
                    </Form-item>
                  </template>
                  <!-- 附件 -->
                  <template slot-scope="{ row }" slot="detailFile">
                    <ab-upload
                      v-model="item.swgysList[row._index].detailFile"
                      abPermission="w"
                      :disabled="permission.swgys.detailFile!=='w'"
                      :format="['pdf','xlsx','xls','doc','docx','ppt','pptx','ofd','jpg','png','jpeg','bmp']"
                    ></ab-upload>
                  </template>
                  <!-- 备注 -->
                  <template slot-scope="{ row }" slot="note">
                    <Tooltip
                        style="width:100%;margin-top:5px;"
                        max-width="400"
                        :disabled="item.swgysList[row._index].note===''"
                        :content="item.swgysList[row._index].note"
                        :transfer="true"
                      >   
                    <FormItem
                      :prop="`items.${index}.swgysList.${row._index}.note`"
                      :rules="rules.note"
                    >
                      <Input
                        type="text"
                        v-model="item.swgysList[row._index].note"
                        :disabled="permission.swgys.note!=='w'"
                      />
                    </FormItem>
                    </Tooltip>
                  </template>
                </Table>
              </div>
            </div>
          </div>
          <!-- <Form-item>
          <Button type="primary" @click="handleSubmitb('formDynamic')">提交</Button>
          <Button type="primary" @click="handleReset('formDynamic')" style="margin-left: 8px">重置</Button>
          </Form-item>-->
        </Form>
      </Card>
      <!-- 服务 -->
      <Card
        style="margin-top:15px;"
        :class="{'cardnonepadding':!formService.items || formService.items.length===0}"
        v-if="formService.items && validate_e"
      >
        <div slot="title" class="title_a_box">
          <span class="title">{{$t('label.Inquiry.Service.ServiceContent')}}</span>
          <!-- <Button type="primary" @click="handleAdd(1)" class="add">
          <Icon type="ios-add" style="margin-right:5px;" />添加
          </Button>-->
        </div>
        <Form ref="formService" :rules="rules" :model="formService" class="form-table-th-margin">
          <!-- 服务明细部分 -->
          <div v-for="(item, index) in formService.items" :key="index">
            <div
              :class="{'content':index !== formService.items.length-1}"
              v-if="getdisplay(item,1)"
            >
              <table class="form-table form-table-print">
                <tbody>
                  <tr>
                    <th class="requiredIitm">{{$t('label.Inquiry.EntrustedContent')}}</th>
                    <td>
                      <Form-item
                        :prop="'items.' + index + '.entrustment'"
                        :rules="rules.entrustment"
                      >
                        <Input type="text" v-model="item.entrustment" placeholder disabled />
                      </Form-item>
                    </td>
                    <th class="requiredIitm">{{$t('label.Inquiry.StartTime')}}</th>
                    <td>
                      <Form-item
                        :prop="'items.' + index + '.businessHoursStart'"
                        :rules="rules.businessHoursStart"
                      >
                        <ab-date
                          :disabled="true"
                          style="width:100%;"
                          v-model="item.businessHoursStart"
                          format="yyyy-MM-dd"
                        ></ab-date>
                      </Form-item>
                    </td>
                    <th class="requiredIitm">{{$t('label.Inquiry.EndTime')}}</th>
                    <td>
                      <Form-item
                        :prop="'items.' + index + '.businessHoursEnd'"
                        :rules="rules.businessHoursEnd"
                      >
                        <ab-date
                          :disabled="true"
                          style="width:100%;"
                          v-model="item.businessHoursEnd"
                          format="yyyy-MM-dd"
                        ></ab-date>
                      </Form-item>
                    </td>
                  </tr>
                  <tr>
                    <th class="requiredIitm">{{$t('label.Inquiry.Service.Safety')}}</th>
                    <td style="text-align:left;">
                      <FormItem
                        :prop="'items.' + index + '.securityType'"
                        :rules="rules.securityType"
                      >
                        <RadioGroup v-model="item.securityType">
                          <Radio label="0" disabled>{{$t('label.Inquiry.Service.WorkHigh')}}</Radio>
                          <Radio label="1" disabled>{{$t('label.Inquiry.Service.FlameCperation ')}}</Radio>
                          <Radio label="2" disabled>{{$t('label.Inquiry.Service.Hydrogen')}}</Radio>
                          <Radio label="3" disabled>{{$t('label.Inquiry.Service.NO')}}</Radio>
                        </RadioGroup>
                      </FormItem>
                    </td>
                    <th class>{{$t('label.Inquiry.Service.Attachment')}}</th>
                    <td>
                      <ab-upload v-model="item.file" abPermission="w" :disabled="true" :format="['pdf','xlsx','xls','doc','docx','ppt','pptx','ofd','jpg','png','jpeg','bmp']"></ab-upload>
                    </td>
                    <th class>{{$t('label.Inquiry.Service.Note')}}</th>
                    <td>
                    <Tooltip
                        style="width:100%;margin-top:5px;"
                        max-width="400"
                        :disabled="item.note===''"
                        :content="item.note"
                        :transfer="true"
                      >    
                      <Form-item :prop="'items.' + index + '.note'">
                        <Input type="text" v-model="item.note" placeholder disabled />
                      </Form-item>
                    </Tooltip>  
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- 理由内容 -->
              <!-- <div class="typebox" v-if="item.fwgysList && item.fwgysList.length===1 && !item.flg">
                <span>相見積もり徹底できない理由 :</span>
                <Form-item :prop="'items.' + index + '.incompleteQr'" :rules="rules.incompleteQr">
                  <RadioGroup v-model="item.incompleteQr" disabled>
                    <Radio label="0" disabled>丰田事业体</Radio>
                    <Radio label="1" disabled>专利持有公司</Radio>
                    <Radio label="2" disabled>大学、研究机构</Radio>
                    <Radio label="3" disabled>合作项目</Radio>
                    <Radio label="4" disabled>其他：（要记入）</Radio>
                  </RadioGroup>
                </Form-item>
                <Form-item
                  :prop="'items.' + index + '.incompleteQrt'"
                  :rules="rules.incompleteQrt"
                  v-if="item.incompleteQr==='4'"
                >
                  <Input type="text" v-model="item.incompleteQrt" placeholder disabled />
                </Form-item>
              </div>-->
              <!-- 服务供应商部分 -->
              <div style="margin-top:15px;">
                <div
                  style="display:flex;justify-content:space-between;margin-bottom:15px;align-items:center;"
                >
                  <!-- <div>
                  <Button type="primary" @click="add(index,1)" style="margin-right:10px;">
                    <Icon type="ios-add" style="margin-right:5px;" />添加供应商
                  </Button>
                  <Button
                    type="primary"
                    @click="copy(index,1)"
                    style="margin-right:10px;"
                    v-if="formDynamic.items.length>0 && formDynamic.items[0].swgysList.length>0"
                  >
                    <Icon type="ios-add" style="margin-right:5px;" />复制供应商
                  </Button>
                  <Button type="error" @click="handleRemove(index,1)">
                    <Icon type="ios-alert-outline" style="margin-right:5px;" />删除明细
                  </Button>
                  </div>-->
                </div>
                <div style="text-align:left;width:100%;color: red;font-size: 12px">
                  <span>{{$t('label.InquiryOfferApprove.Tips001')}}</span>
                </div>
                <Table
                  border
                  :columns="userId==='admin' ? columns_all : columns"
                  :data="item.fwgysList"
                  :no-data-text="''"
                  v-if="item.fwgysList && item.fwgysList.length>0"
                >
                  <!-- 供应商名称 -->
                  <template slot-scope="{ row }" slot="vendorName">
                    <Tooltip
                      max-width="400"
                      style="display:flex;width:100%;"
                      :disabled="item.fwgysList[row._index].vendorName===''"
                      :content="item.fwgysList[row._index].vendorName"
                      :transfer="true"
                    >
                      <FormItem
                        :prop="`items.${index}.fwgysList.${row._index}.vendorName`"
                        :rules="rules.vendorName"
                      >
                        <Input
                          type="text"
                          v-model="item.fwgysList[row._index].vendorName"
                          disabled
                        />
                      </FormItem>
                    </Tooltip>
                  </template>
                  <!-- 委托人 -->
                  <template slot-scope="{ row }" slot="client">
                    <FormItem
                      :prop="`items.${index}.fwgysList.${row._index}.client`"
                      :rules="rules.client"
                    >
                      <Input type="text" v-model="item.fwgysList[row._index].client" disabled />
                    </FormItem>
                  </template>
                  <!-- 联系方式 -->
                  <template slot-scope="{ row }" slot="contact">
                    <Tooltip
                      style="display:flex;width:100%;"
                      max-width="400"
                      :content="item.fwgysList[row._index].contact"
                      :transfer="true"
                    >
                      <FormItem
                        :prop="`items.${index}.fwgysList.${row._index}.contact`"
                        :rules="rules.contact"
                      >
                        <Input
                          type="text"
                          v-model="item.fwgysList[row._index].contact"
                          :maxlength="300"
                          disabled
                        />
                      </FormItem>
                    </Tooltip>
                  </template>
                  <!-- 委托人邮箱 -->
                  <template slot-scope="{ row }" slot="email">
                    <Tooltip
                      max-width="400"
                      style="display:flex;width:100%;"
                      :disabled="item.fwgysList[row._index].email===''"
                      :content="item.fwgysList[row._index].email"
                      :transfer="true"
                    >
                      <FormItem
                        :prop="`items.${index}.fwgysList.${row._index}.email`"
                        :rules="rules.email"
                      >
                        <Input type="text" v-model="item.fwgysList[row._index].email" disabled />
                      </FormItem>
                    </Tooltip>
                  </template>
                  <!-- 不含税价格 -->
                  <template slot-scope="{ row }" slot="excludingTaxPrice">
                    <FormItem
                      :prop="`items.${index}.fwgysList.${row._index}.excludingTaxPrice`"
                      :rules="returnCheck(item.fwgysList[row._index]) ? [{ type:'number',trigger: 'change',validator:(rule,value,callback)=>{priceCheck(rule,value,callback,1,row)}}] : null"
                    >
                      <InputNumber
                        :disabled="permission.fwgys.excludingTaxPrice!=='w'"
                        @on-change="numberchange($event,item.fwgysList[row._index],0)"
                        :active-change="false"
                        :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="value => value.replace(/\s?|(,*)/g, '')"
                        :precision="2"
                        style="width:100%;"
                        :min="0"
                        v-model="item.fwgysList[row._index].excludingTaxPrice"
                      ></InputNumber>
                    </FormItem>
                  </template>
                  <!-- 含税价格 -->
                  <template slot-scope="{ row }" slot="includingTaxPrice">
                    <FormItem
                      :prop="`items.${index}.fwgysList.${row._index}.includingTaxPrice`"
                      :rules="returnCheck(item.fwgysList[row._index]) ? [{ type:'number',trigger: 'change',validator:(rule,value,callback)=>{priceCheck(rule,value,callback,0,row)}}] : null"
                    >
                      <InputNumber
                        :disabled="permission.fwgys.includingTaxPrice!=='w'"
                        @on-change="numberchange($event,item.fwgysList[row._index],1)"
                        :active-change="false"
                        :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="value => value.replace(/\s?|(,*)/g, '')"
                        :precision="2"
                        style="width:100%;"
                        :min="0"
                        v-model="item.fwgysList[row._index].includingTaxPrice"
                      ></InputNumber>
                    </FormItem>
                  </template>
                  <!-- 比价金额 -->
                  <template slot-scope="{ row }" slot="priceAmount">
                    <FormItem
                      :prop="`items.${index}.fwgysList.${row._index}.priceAmount`"
                      :rules="returnCheck(item.fwgysList[row._index]) ? rules.priceAmount : null"
                    >
                      <InputNumber
                        :active-change="false"
                        :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="value => value.replace(/\s?|(,*)/g, '')"
                        :precision="2"
                        style="width:100%;"
                        disabled
                        :min="0"
                        v-model="item.fwgysList[row._index].priceAmount"
                      ></InputNumber>
                    </FormItem>
                  </template>
                  <!-- 税率 -->
                  <!-- <template slot-scope="{ row }" slot="taxRate">
                    <FormItem
                      :prop="`items.${index}.fwgysList.${row._index}.taxRate`"
                      :rules="returnCheck(item.fwgysList[row._index]) ? rules.taxRate : null"
                    >
                      <InputNumber
                        :precision="2"
                        disabled
                        :formatter="value => `${value}%`"
                        :parser="value => value.replace('%', '')"
                        style="width:100%;"
                        :min="0"
                        v-model="item.fwgysList[row._index].taxRate"
                      ></InputNumber>
                    </FormItem>
                  </template>-->
                  <!-- 发票区分 -->
                  <template slot-scope="{ row }" slot="invoiceType">
                    <FormItem
                      :prop="`items.${index}.fwgysList.${row._index}.invoiceType`"
                      :rules="returnCheck(item.fwgysList[row._index]) ? rules.invoiceType : null"
                    >
                      <RadioGroup
                        v-model="item.fwgysList[row._index].invoiceType"
                        @on-change="numberchange($event,item.fwgysList[row._index],2)"
                      >
                        <Radio
                          :disabled="permission.fwgys.invoiceType!=='w'"
                          label="0"
                        >{{$t('label.Inquiry.GeneralTicket')}}</Radio>
                        <Radio
                          :disabled="permission.fwgys.invoiceType!=='w'"
                          label="1"
                        >{{$t('label.Inquiry.TicketIncrease')}}</Radio>
                      </RadioGroup>
                    </FormItem>
                  </template>
                  <!-- 报价有效开始日 -->
                  <template slot-scope="{ row }" slot="priceStartDate">
                    <Form-item
                      :prop="`items.${index}.fwgysList.${row._index}.priceStartDate`"
                      :rules="returnCheck(item.fwgysList[row._index]) ? [{ trigger: 'change',validator:(rule,value,callback)=>{validateDate(rule,value,callback,row,0)}}] : null"
                    >
                      <ab-date
                        :disabled="permission.fwgys.priceStartDate!=='w'"
                        style="width:100%;"
                        v-model="item.fwgysList[row._index].priceStartDate"
                        format="yyyy-MM-dd"
                      ></ab-date>
                    </Form-item>
                  </template>
                  <!-- 报价有效截至日 -->
                  <template slot-scope="{ row }" slot="priceEndDate">
                    <Form-item
                      :prop="`items.${index}.fwgysList.${row._index}.priceEndDate`"
                      :rules="returnCheck(item.fwgysList[row._index]) ? [{ trigger: 'change',validator:(rule,value,callback)=>{validateDate(rule,value,callback,row,1)}}] : null"
                    >
                      <ab-date
                        :disabled="permission.fwgys.priceEndDate!=='w'"
                        style="width:100%;"
                        v-model="item.fwgysList[row._index].priceEndDate"
                        format="yyyy-MM-dd"
                      ></ab-date>
                    </Form-item>
                  </template>
                  <!-- 附件 -->
                  <template slot-scope="{ row }" slot="detailFile">
                    <ab-upload
                      v-model="item.fwgysList[row._index].detailFile"
                      abPermission="w"
                      :disabled="permission.fwgys.detailFile!=='w'"
                      :format="['pdf','xlsx','xls','doc','docx','ppt','pptx','ofd','jpg','png','jpeg','bmp']"
                    ></ab-upload>
                  </template>
                  <!-- 备注 -->
                  <template slot-scope="{ row }" slot="note">
                    <Tooltip
                        style="width:100%;margin-top:5px;"
                        max-width="400"
                        :disabled="item.fwgysList[row._index].note===''"
                        :content="item.fwgysList[row._index].note"
                        :transfer="true"
                      >    
                        <FormItem
                          :prop="`items.${index}.fwgysList.${row._index}.note`"
                          :rules="rules.note"
                        >
                          <Input
                            type="text"
                            v-model="item.fwgysList[row._index].note"
                            :disabled="permission.fwgys.note!=='w'"
                          />
                        </FormItem>
                    </Tooltip>    
                  </template>
                </Table>
              </div>
            </div>
          </div>
          <!-- <Form-item>
          <Button type="primary" @click="handleSubmitb('formDynamic')">提交</Button>
          <Button type="primary" @click="handleReset('formDynamic')" style="margin-left: 8px">重置</Button>
          </Form-item>-->
        </Form>
      </Card>
    </Card>
  </div>
</template>
<script>
import util from "@/libs/util";
export default {
  data: function() {
    return {
      contactList: [
        {
          name: $t("label.Inquiry.Camera"),
          content: $t("label.Inquiry.LegalAffairs"),
          contactNumber: $t("label.Inquiry.Liyan")
        },
        {
          name: $t("label.Inquiry.Display"),
          content: $t("label.Inquiry.SystemCourse"),
          contactNumber: $t("label.Inquiry.LiuYuanYuan")
        },
        {
          name: $t("label.Inquiry.Stationery"),
          content: $t("label.Inquiry.GeneralAffairsSection"),
          contactNumber: $t("label.Inquiry.ChenYan")
        },
        {
          name: $t("label.Inquiry.VehicleRelated"),
          content: $t("label.Inquiry.SupportDepartment"),
          contactNumber: $t("label.Inquiry.GuLingYan")
        },
        {
          name: $t("label.Inquiry.SpareParts"),
          content: $t("label.Inquiry.SupportDepartment"),
          contactNumber: $t("label.Inquiry.DingXianHua")
        },
        {
          name: $t("label.Inquiry.VehicleAccess"),
          content: $t("label.Inquiry.SupportDepartment"),
          contactNumber: $t("label.Inquiry.ZhangYiTing")
        }
      ],
      sqr: "",
      detail: false,
      userId: null,
      list_a: [],
      list_b: [],
      pmdisplayflg: false,
      //实物数据
      formDynamic: {
        items: [
          {
            itemName: "",
            specifications: "",
            quantity: "",
            deliveryDeadline: "",
            note: "",
            file: "",
            incompleteQr: "",
            incompleteQrt: "",
            swgysList: []
          }
        ]
      },
      //服务数据
      formService: {
        items: [
          {
            entrustment: "",
            businessHoursStart: "",
            businessHoursEnd: "",
            securityType: "",
            note: "",
            file: "",
            incompleteQr: "",
            incompleteQrt: "",
            fwgysList: []
          }
        ]
      },
      //供应商校验规则
      rules: {
        //实物明细
        itemName: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.Physical.Item"),
            trigger: "change"
          }
        ],
        specifications: [
          {
            required: true,
            message:
              $t("ERR-000") + $t("label.Inquiry.Physical.Specifications"),
            trigger: "change"
          }
        ],
        note: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.Physical.Note"),
            trigger: "change"
          }
        ],
        deliveryDeadline: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.Physical.Satisfied"),
            trigger: "change"
          }
        ],
        quantity: [
          {
            required: true,
            type: "number",
            message: $t("ERR-000") + $t("label.Inquiry.Physical.Sum"),
            trigger: "change"
          }
        ],

        //服务明细
        entrustment: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.EntrustedContent"),
            trigger: "change"
          }
        ],
        securityType: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.Service.Safety"),
            trigger: "change"
          }
        ],
        file: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.Physical.Attachment"),
            trigger: "change"
          }
        ],
        businessHoursStart: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.StartTime"),
            trigger: "change"
          }
        ],
        businessHoursEnd: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.EndTime"),
            trigger: "change"
          }
        ],
        //共用供应商校验
        incompleteQr: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.Reason"),
            trigger: "change"
          }
        ],
        incompleteQrt: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.Other"),
            trigger: "change"
          }
        ],
        vendorId: [
          {
            required: true,
            message:
              $t("ERR-000") +
              $t("label.InquiryInvitationApply.SupplierDetail.SupplierID"),
            trigger: "change"
          }
        ],
        vendorName: [
          {
            required: true,
            message:
              $t("ERR-000") +
              $t("label.InquiryInvitationApply.SupplierDetail.SupplierName"),
            trigger: "change"
          }
        ],
        client: [
          {
            required: true,
            message:
              $t("ERR-000") +
              $t("label.InquiryInvitationApply.SupplierDetail.Contact"),
            trigger: "change"
          }
        ],
        email: [
          {
            required: true,
            message:
              $t("ERR-000") +
              $t("label.InquiryInvitationApply.SupplierDetail.Email"),
            trigger: "change"
          }
        ],
        contact: [
          {
            required: true,
            message:
              $t("ERR-000") +
              $t("label.InquiryInvitationApply.SupplierDetail.Phone"),
            trigger: "change"
          }
        ],
        //不含税价格
        excludingTaxPrice: [
          {
            type: "number",
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!value) {
                callback(
                  value === 0
                    ? $t("ERR.Inquiry.005")
                    : util.getmsg(
                        this,
                        "label.InquiryOfferApprove.SupplierDetail.PriceExcluding"
                      )
                );
              } else {
                callback();
              }
            }
          }
        ],
        //含税价格
        includingTaxPrice: [
          {
            type: "number",
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!value) {
                callback(
                  value === 0
                    ? $t("ERR.Inquiry.006")
                    : util.getmsg(
                        this,
                        "label.InquiryOfferApprove.SupplierDetail.PostTaxPrices"
                      )
                );
              } else {
                callback();
              }
            }
          }
        ],
        priceAmount: [
          {
            required: true,
            type: "number",
            message: util.getmsg(
              this,
              "label.InquiryOfferApprove.SupplierDetail.PriceAmount"
            ),
            trigger: "change"
          }
        ],
        taxRate: [
          {
            required: true,
            type: "number",
            message: util.getmsg(
              this,
              "label.InquiryOfferApprove.SupplierDetail.Rate"
            ),
            trigger: "change"
          }
        ],
        invoiceType: [
          {
            required: true,
            message: util.getmsg(
              this,
              "label.InquiryOfferApprove.SupplierDetail.Invoice"
            ),
            trigger: "change"
          }
        ],
        priceStartDate: [
          {
            trigger: "change",
            message: util.getmsg(
              this,
              "label.InquiryOfferApprove.SupplierDetail.QuotationStart"
            ),
            required: true
          }
        ],
        priceEndDate: [
          {
            trigger: "change",
            message: util.getmsg(
              this,
              "label.InquiryOfferApprove.SupplierDetail.QuotationEnd"
            ),
            required: true
          }
        ],
        detailFile: [
          {
            required: true,
            message: util.getmsg(
              this,
              "label.InquiryOfferApprove.SupplierDetail.Attachment"
            ),
            trigger: "change"
          }
        ],
        note: [
          {
            required: false,
            message: util.getmsg(this, "label.Inquiry.Physical.Note"),
            trigger: "change"
          }
        ]
      },
      // 供应商明细校验规则
      // 主表校验规则
      rule: {
        breakupBidFlg: [
          {
            required: true,
            message: util.getmsg(this, "label.InquiryOfferApprove.Separable"),
            trigger: "change"
          }
        ],
        applicantUserId: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.Client"),
            trigger: "change"
          }
        ],
        applyDepartmentName: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.EntrustedDepartment"),
            trigger: "change"
          }
        ],
        applyDate: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.EntrustDate"),
            trigger: "change"
          }
        ],
        quoteDeadline: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.Deadline"),
            trigger: "change"
          }
        ],
        inquiryId: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.InquiryNo"),
            trigger: "change"
          }
        ],
        objective: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.Purpose"),
            trigger: "change"
          }
        ]
      }
    };
  },
  props: {
    parent: {
      //默认数据
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  created() {
    this.formdata = this.parent.data.xjsq;
    this.permission = this.parent.permission.xjsq;
    this.formDynamic.items = this.formdata.xjswgrList;
    this.formService.items = this.formdata.fwxxList;
    this.detail = !this.$parent.instance
      ? false
      : this.$parent.instance.status === "end" ||
        this.$parent.instance.status === "running"
      ? true
      : this.$parent.instance.status === "draft"
      ? false
      : false;
    //重置数字参数
    this.initNumber();
    //获取是否拆分报价
    this.getUser();
    this.abHttpUtil
      .post("/common/getFullName?account=" + this.formdata.applicantUserId)
      .then(res => {
        this.sqr = res;
      });
  },
  computed: {
    //实物表格列
    columns() {
      return [
        //发票区分
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.Invoice"),
          slot: "invoiceType",
          align: "center",
          width: 130,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.Invoice")
            );
          }
        },
        //含税价格
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.PostTaxPrices"),
          slot: "includingTaxPrice",
          align: "center",
          width: 140,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.PostTaxPrices")
            );
          }
        },
        //不含税价格
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.PriceExcluding"),
          slot: "excludingTaxPrice",
          align: "center",
          width: 140,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.PriceExcluding")
            );
          }
        },
        //比价金额
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.PriceAmount"),
          slot: "priceAmount",
          align: "center",
          width: 140,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.PriceAmount")
            );
          }
        },
        //税率
        // {
        //   title: $t("label.InquiryOfferApprove.SupplierDetail.Rate"),
        //   slot: "taxRate",
        //   align: "center",
        //   width: 200,
        //   renderHeader: (h, params) => {
        //     return h(
        //       "div",
        //       { class: "requiredIitm" },
        //       $t("label.InquiryOfferApprove.SupplierDetail.Rate")
        //     );
        //   }
        // },
        //报价开始日
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.QuotationStart"),
          slot: "priceStartDate",
          align: "center",
          width: 130,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.QuotationStart")
            );
          }
        },
        //报价终了日
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.QuotationEnd"),
          slot: "priceEndDate",
          align: "center",
          width: 130,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.QuotationEnd")
            );
          }
        },
        //附件
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.Attachment"),
          slot: "detailFile",
          align: "center",
          width: 160,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.Attachment")
            );
          }
        },
        //备考
        {
          title: $t("label.Inquiry.Physical.Note"),
          slot: "note",
          align: "center",
          width: 200,
          filters: [
            {
              label: this.userId,
              value: this.userId
            }
          ],
          filteredValue: [this.userId],
          filterMethod(value, row) {
            return row.vendorId === value;
          }
        },
        //供应商名称
        {
          title: $t("label.InquiryInvitationApply.SupplierDetail.SupplierName"),
          slot: "vendorName",
          align: "center",
          width: 200,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryInvitationApply.SupplierDetail.SupplierName")
            );
          }
        },
        //联系人
        {
          title: $t("label.InquiryInvitationApply.SupplierDetail.Contact"),
          slot: "client",
          align: "center",
          width: 150,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryInvitationApply.SupplierDetail.Contact")
            );
          }
        },
        //电话
        {
          title: $t("label.InquiryInvitationApply.SupplierDetail.Phone"),
          slot: "contact",
          align: "center",
          width: 160,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryInvitationApply.SupplierDetail.Phone")
            );
          }
        },
        //邮箱
        {
          title: $t("label.InquiryInvitationApply.SupplierDetail.Email"),
          slot: "email",
          align: "center",
          width: 210,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryInvitationApply.SupplierDetail.Email")
            );
          }
        }
      ];
    },
    columns_all() {
      return [
        //发票区分
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.Invoice"),
          slot: "invoiceType",
          align: "center",
          width: 130,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.Invoice")
            );
          }
        },
        //含税价格
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.PostTaxPrices"),
          slot: "includingTaxPrice",
          align: "center",
          width: 140,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.PostTaxPrices")
            );
          }
        },
        //不含税价格
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.PriceExcluding"),
          slot: "excludingTaxPrice",
          align: "center",
          width: 140,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.PriceExcluding")
            );
          }
        },
        //比价金额
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.PriceAmount"),
          slot: "priceAmount",
          align: "center",
          width: 140,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.PriceAmount")
            );
          }
        },
        //税率
        // {
        //   title: $t("label.InquiryOfferApprove.SupplierDetail.Rate"),
        //   slot: "taxRate",
        //   align: "center",
        //   width: 200,
        //   renderHeader: (h, params) => {
        //     return h(
        //       "div",
        //       { class: "requiredIitm" },
        //       $t("label.InquiryOfferApprove.SupplierDetail.Rate")
        //     );
        //   }
        // },
        //报价开始日
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.QuotationStart"),
          slot: "priceStartDate",
          align: "center",
          width: 130,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.QuotationStart")
            );
          }
        },
        //报价结束日
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.QuotationEnd"),
          slot: "priceEndDate",
          align: "center",
          width: 130,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.QuotationEnd")
            );
          }
        },
        //附件
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.Attachment"),
          slot: "detailFile",
          align: "center",
          width: 160,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.Attachment")
            );
          }
        },
        //备注
        {
          title: $t("label.Inquiry.Physical.Note"),
          slot: "note",
          align: "center",
          width: 200
        },
        //供应商名称
        {
          title: $t("label.InquiryInvitationApply.SupplierDetail.SupplierName"),
          slot: "vendorName",
          align: "center",
          width: 200,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryInvitationApply.SupplierDetail.SupplierName")
            );
          }
        },
        //联系人
        {
          title: $t("label.InquiryInvitationApply.SupplierDetail.Contact"),
          slot: "client",
          align: "center",
          width: 150,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryInvitationApply.SupplierDetail.Contact")
            );
          }
        },
        //电话
        {
          title: $t("label.InquiryInvitationApply.SupplierDetail.Phone"),
          slot: "contact",
          align: "center",
          width: 160,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryInvitationApply.SupplierDetail.Phone")
            );
          }
        },
        //邮箱
        {
          title: $t("label.InquiryInvitationApply.SupplierDetail.Email"),
          slot: "email",
          align: "center",
          width: 210,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryInvitationApply.SupplierDetail.Email")
            );
          }
        }
      ];
    },
    validate_d() {
      var flg =
        this.userId === "admin"
          ? true
          : this.formDynamic.items.some(val => {
              return val.swgysList.some(item => {
                return item.vendorId === this.userId;
              });
            });
      return flg;
    },
    validate_e() {
      var flg =
        this.userId === "admin"
          ? true
          : this.formService.items.some(val => {
              return val.fwgysList.some(item => {
                return item.vendorId === this.userId;
              });
            });
      return flg;
    },
    validate_f() {
      var list = [];
      if (
        this.formDynamic.items.length > 0 &&
        this.formdata.breakupBidFlg === "1"
      ) {
        this.formDynamic.items.forEach(val => {
          val.swgysList.forEach(item => {
            if (item.vendorId === this.userId) {
              list.push(item);
            }
          });
        });
      }

      if (
        this.formService.items.length > 0 &&
        this.formdata.breakupBidFlg === "1"
      ) {
        this.formService.items.forEach(val => {
          val.fwgysList.forEach(item => {
            if (item.vendorId === this.userId) {
              list.push(item);
            }
          });
        });
      }
      var flg_a = list.some(val => {
        return val.excludingTaxPrice &&
          val.includingTaxPrice &&
          val.priceAmount &&
          val.taxRate &&
          val.invoiceType &&
          val.priceStartDate &&
          val.priceEndDate
          ? true
          : false;
      });
      return flg_a;
    },
    //获取是否拆分报价
    breakupBidFlg() {
      var value = "";
      if (this.formDynamic.items.length > 0) {
        this.formDynamic.items.forEach(val => {
          val.swgysList.forEach(item => {
            if (item.vendorId === this.userId) {
              value = item.breakupBidFlg;
            }
          });
        });
      }
      if (this.formService.items.length > 0) {
        this.formService.items.forEach(val => {
          val.fwgysList.forEach(item => {
            if (item.vendorId === this.userId) {
              value = item.breakupBidFlg;
            }
          });
        });
      }
      return value;
    }
  },
  mounted() {
    //重置数字参数
    if (this.formDynamic.items) {
      this.formDynamic.items.forEach(item => {
        item.swgysList.forEach(val => {
          if (!val.excludingTaxPrice) {
            this.$set(val, "excludingTaxPrice", null);
            this.$set(val, "includingTaxPrice", null);
            this.$set(val, "priceAmount", null);
            this.$set(val, "taxRate", null);
          }
        });
      });
    }
    if (this.formService.items) {
      this.formService.items.forEach(item => {
        item.fwgysList.forEach(val => {
          if (!val.excludingTaxPrice) {
            this.$set(val, "excludingTaxPrice", null);
            this.$set(val, "includingTaxPrice", null);
            this.$set(val, "priceAmount", null);
            this.$set(val, "taxRate", null);
          }
        });
      });
    }
  },
  methods: {
    //获取当前登录者信息
    getUser() {
      this.abHttpUtil.post("/inquiryOfferApprove/getUserDate", {}).then(res => {
        this.userId = res.account;
        this.$set(this.formdata, "breakupBidFlg", this.getValue());
      });
    },
    //表单提交
    // formdata
    // formDynamic
    // formService
    handleSubmit() {
      let flg = 0;
      let validateflg = false;
      this.$refs.formdata.validate(valid => {
        if (valid) {
          flg++;
        }
      });
      if (this.$refs.formDynamic) {
        this.$refs.formDynamic.validate(valid => {
          if (valid) {
            flg++;
          }
        });
      }
      if (this.$refs.formService) {
        this.$refs.formService.validate(valid => {
          if (valid) {
            flg++;
          }
        });
      }

      var count =
        this.formDynamic.items && this.formService.items
          ? 3
          : this.formDynamic.items || this.formService.items
          ? 2
          : 999;
      flg = !this.validate_d || !this.validate_e ? flg + 1 : flg;
      if (flg === count) {
        this.$parent.data.xjsq = { ...this.formdata };
        this.$parent.data.xjsq.xjswgrList = this.formDynamic.items;
        this.$parent.data.xjsq.fwxxList = this.formService.items;
        validateflg = true;
      } else {
        var list = [];
        //不接受拆分报价，必须填写所有实物以及服务的价格信息。
        if (this.formdata.breakupBidFlg === "0") {
          list.push($t("ERR.Inquiry.011"));
        }
        //接受拆分报价，请至少填写一行实物或者服务的价格信息。
        if (this.formdata.breakupBidFlg === "1" && !this.validate_f) {
          list.push($t("ERR.Inquiry.012"));
        }
        this.errmsg(list);
        validateflg = false;
      }
      return validateflg;
    },
    //表单重置
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    // 品目鼠标移入事件
    pmdisplayover() {
      this.pmdisplayflg = true;
    },
    // 品目鼠标移出事件
    pmdisplayout() {
      this.pmdisplayflg = false;
    },
    //明细添加
    handleAdd(type) {
      if (type === 0) {
        this.formDynamic.items.push({
          itemName: "",
          specifications: "",
          quantity: "",
          deliveryDeadline: "",
          note: "",
          file: "",
          incompleteQr: "",
          incompleteQrt: "",
          swgysList: []
        });
      } else if (type === 1) {
        this.formService.items.push({
          entrustment: "",
          businessHoursStart: "",
          businessHoursEnd: "",
          securityType: "",
          note: "",
          file: "",
          incompleteQr: "",
          incompleteQrt: "",
          fwgysList: []
        });
      }
    },
    //明细删除
    handleRemove(index, type) {
      if (type === 0) {
        this.formDynamic.items.splice(index, 1);
      } else if (type === 1) {
        this.formService.items.splice(index, 1);
      }
    },
    //删除供应商
    remove(index, row, type) {
      if (type === 0) {
        this.formDynamic.items[index].swgysList.splice(row._index, 1);
      } else if (type === 1) {
        this.formService.items[index].fwgysList.splice(row._index, 1);
      }
    },
    // 添加供应商
    add(index, type) {
      let obj = {
        vendorId: "",
        vendorName: "",
        client: "",
        priceAmount: "",
        contact: "",
        email: "",
        excludingTaxPrice: null,
        includingTaxPrice: null,
        priceAmount: null,
        taxRate: null,
        invoiceType: "",
        priceStartDate: "",
        priceEndDate: "",
        detailFile: "",
        note: ""
      };
      if (type === 0) {
        this.formDynamic.items[index].swgysList.push(obj);
      } else if (type === 1) {
        this.formService.items[index].fwgysList.push(obj);
      }
    },
    //供应商复制
    copy(index, type) {
      if (type === 0) {
        this.formDynamic.items[
          index
        ].swgysList = this.formDynamic.items[0].swgysList;
      }
      if (type === 1) {
        this.formService.items[
          index
        ].fwgysList = this.formDynamic.items[0].swgysList;
      }
    },
    //model添加供应商
    pushOrgRelationList(dataArr, type, obj) {
      if (!dataArr) {
        return;
      }
      if (type === 0) {
        obj.vendorId = dataArr[0].supplierid;
        obj.vendorName = dataArr[0].suppliernamecn;
        obj.client = dataArr[0].contact;
        obj.contact = dataArr[0].telno;
        obj.email = dataArr[0].mailaddress;
      }
      if (type === 1) {
        obj.vendorId = dataArr[0].supplierid;
        obj.vendorName = dataArr[0].suppliernamecn;
        obj.client = dataArr[0].contact;
        obj.contact = dataArr[0].telno;
        obj.email = dataArr[0].mailaddress;
      }
    },
    //税率，比价金额计算事件
    numberchange(e, data, type) {
      // 0不含税金额 excludingTaxPrice
      // 1含税金额 includingTaxPrice
      // 2普票/增票 invoiceType
      // 比价金额 priceAmount
      // 税率 taxRate
      if (type === 0) {
        if (data.invoiceType === "1") {
          //增票为不含税金额
          data.priceAmount = e;
        }
        if (data.includingTaxPrice && data.includingTaxPrice !== "") {
          data.taxRate = ((data.includingTaxPrice - e) / e) * 100;
        }
      }
      if (type === 1) {
        if (data.invoiceType === "0") {
          //普票为含税金额
          data.priceAmount = e;
        }
        if (data.excludingTaxPrice && data.excludingTaxPrice !== "") {
          data.taxRate =
            ((e - data.excludingTaxPrice) / data.excludingTaxPrice) * 100;
        }
      }
      if (type === 2) {
        //e=1增票时使用不含税金额
        //e=0普票是使用含税金额
        data.priceAmount =
          e === "1"
            ? data.excludingTaxPrice
            : e === "0"
            ? data.includingTaxPrice
            : "";
      }
    },
    errmsg(custom) {
      this.$nextTick(() => {
        var errMsg = [];
        var errList = document.querySelectorAll(".ivu-form-item-error-tip");
        errList.forEach(val => {
          if (errMsg.indexOf(val.innerHTML) == -1) {
            errMsg.push(val.innerHTML);
          }
        });
        if (custom.length > 0) {
          errMsg = errMsg.concat(custom);
        }
        errMsg.forEach(val => {
          this.$Message.error({ content: val, duration: 5 });
        });
      });
    },
    setValue(value) {
      this.$set(this.formdata, "breakupBidFlg", value);
      this.formDynamic.items.forEach(val => {
        val.swgysList.forEach(item => {
          if (item.vendorId === this.userId) {
            item.breakupBidFlg = value;
          }
        });
      });
      this.formService.items.forEach(val => {
        val.fwgysList.forEach(item => {
          if (item.vendorId === this.userId) {
            item.breakupBidFlg = value;
          }
        });
      });
    },
    getValue() {
      var value = "";
      if (this.formDynamic.items) {
        this.formDynamic.items.forEach(val => {
          val.swgysList.forEach(item => {
            if (item.vendorId === this.userId) {
              value = item.breakupBidFlg ? item.breakupBidFlg : "";
            }
          });
        });
      }
      if (this.formService.items) {
        this.formService.items.forEach(val => {
          val.fwgysList.forEach(item => {
            if (item.vendorId === this.userId) {
              value = item.breakupBidFlg ? item.breakupBidFlg : "";
            }
          });
        });
      }
      return value;
    },
    getdisplay(list, type) {
      var flg = false;
      if (this.userId === "admin") {
        flg = true;
        return flg;
      }
      if (type == 0) {
        flg = list.swgysList.some(val => {
          return val.vendorId === this.userId;
        });
      }
      if (type === 1) {
        flg = list.fwgysList.some(val => {
          return val.vendorId === this.userId;
        });
      }
      return flg;
    },
    validateDate(rule, value, callback, row, type) {
      var start =
        type === 0
          ? this.moment(value)
              .format("YYYY-MM-DD")
              .replace(/-/g, "")
          : this.moment(row.priceStartDate)
              .format("YYYY-MM-DD")
              .replace(/-/g, "");
      var end =
        type === 0
          ? this.moment(row.priceStartDate)
              .format("YYYY-MM-DD")
              .replace(/-/g, "")
          : this.moment(value)
              .format("YYYY-MM-DD")
              .replace(/-/g, "");
      var nowDate = this.moment(new Date())
        .format("YYYY-MM-DD")
        .replace(/-/g, "");
      if (!value) {
        callback(
          type === 0
            ? util.getmsg(
                this,
                "label.InquiryOfferApprove.SupplierDetail.QuotationStart"
              )
            : util.getmsg(
                this,
                "label.InquiryOfferApprove.SupplierDetail.QuotationEnd"
              )
        );
      } else if (start > end) {
        callback($t("ERR.Inquiry.007"));
      } else if (type === 1 && nowDate > end) {
        callback($t("ERR.Inquiry.014"));
      } else {
        callback();
      }
    },
    //重置数字字段参数
    initNumber() {
      if (this.formDynamic.items.length > 0) {
        this.formDynamic.items.forEach(val => {
          val.swgysList.forEach(item => {
            if (!item.excludingTaxPrice) {
              this.$set(item, "excludingTaxPrice", null);
            }
            if (!item.includingTaxPrice) {
              this.$set(item, "includingTaxPrice", null);
            }
            if (!item.priceAmount) {
              this.$set(item, "priceAmount", null);
            }
            if (!item.taxRate) {
              this.$set(item, "taxRate", null);
            }
          });
        });
      }
      if (this.formService.items.length > 0) {
        this.formService.items.forEach(val => {
          val.fwgysList.forEach(item => {
            if (!item.excludingTaxPrice) {
              this.$set(item, "excludingTaxPrice", null);
            }
            if (!item.includingTaxPrice) {
              this.$set(item, "includingTaxPrice", null);
            }
            if (!item.priceAmount) {
              this.$set(item, "priceAmount", null);
            }
            if (!item.taxRate) {
              this.$set(item, "taxRate", null);
            }
          });
        });
      }
    },

    //判断当前明细行是否有填写
    returnCheck(data) {
      var flg_a = false;
      if (
        data.excludingTaxPrice ||
        data.includingTaxPrice ||
        data.priceAmount ||
        data.taxRate ||
        data.invoiceType ||
        data.priceStartDate ||
        data.priceEndDate
      ) {
        flg_a = true;
      } else {
        flg_a = false;
      }
      return this.formdata.breakupBidFlg === "0"
        ? true
        : this.validate_f
        ? flg_a
        : true;
    },
    //含税不含税校验
    priceCheck(rule, value, callback, type, row) {
      //含税价格 includingTaxPrice
      if (type === 0) {
        if (!value) {
          callback(
            value === 0
              ? $t("ERR.Inquiry.006")
              : util.getmsg(
                  this,
                  "label.InquiryOfferApprove.SupplierDetail.PostTaxPrices"
                )
          );
        } else if (value < row.excludingTaxPrice && row.excludingTaxPrice) {
          callback($t("ERR.Inquiry.013"));
        } else {
          callback();
        }
      }
      //不含税价格 excludingTaxPrice
      if (type === 1) {
        if (!value) {
          callback(
            value === 0
              ? $t("ERR.Inquiry.005")
              : util.getmsg(
                  this,
                  "label.InquiryOfferApprove.SupplierDetail.PriceExcluding"
                )
          );
        } else if (value > row.includingTaxPrice && row.includingTaxPrice) {
          callback($t("ERR.Inquiry.013"));
        } else {
          callback();
        }
      }
    }
  }
};
</script>
<style scoped>
.title {
  font-size: 15px;
  font-weight: bold;
  color: #2d8cf0;
}
.titlebox {
  display: flex;
  align-items: center;
}
.typebox {
  display: flex;
  align-items: center;
  margin: 15px 0px;
}
.typebox > span {
  margin-right: 5px;
}
</style>
